<div (click)="focus()"
    class="d-flex rounded-2 background-light-gray m-1 p-2 gap-2 pointer pointer-hover-blue">
    <app-bluetooth-svg [status]="status()" class="img-fluid img-max px-2"></app-bluetooth-svg>
    <div class="d-flex flex-column justify-content-center">
        <div class="fw-bold text-truncate">{{ proximitySamplePoint()?.name }}</div>
        <div class="{{ statusMessageColorClass() }}">{{ statusMessage() }}</div>
        @if (proximitySamplePoint()?.synchronizationStatus === SynchronizationStatus.syncPending) {
            <i class="fa-solid fa-hourglass-half color-warning"></i>
        }
    </div>
</div>